import * as React from 'react';
/** @hidden */
export var SchedulerEditTaskRemoveItemContext = React.createContext([null]);
/** @hidden */
export var useSchedulerEditTaskRemoveItemContext = function () { return React.useContext(SchedulerEditTaskRemoveItemContext); };
/** @hidden */
export var SchedulerEditTaskShowRemoveDialogContext = React.createContext([false]);
/** @hidden */
export var useSchedulerEditTaskShowRemoveDialogContext = function () { return React.useContext(SchedulerEditTaskShowRemoveDialogContext); };
/** @hidden */
export var SchedulerEditTaskShowOccurrenceDialogContext = React.createContext([false]);
/** @hidden */
export var useSchedulerEditTaskShowOccurrenceDialogContext = function () { return React.useContext(SchedulerEditTaskShowOccurrenceDialogContext); };
/** @hidden */
export var SchedulerEditTaskContext = function (props) {
    return (React.createElement(SchedulerEditTaskRemoveItemContext.Provider, { value: props.remove },
        React.createElement(SchedulerEditTaskShowRemoveDialogContext.Provider, { value: props.showRemoveDialog },
            React.createElement(SchedulerEditTaskShowOccurrenceDialogContext.Provider, { value: props.showOccurrenceDialog }, props.children))));
};
//# sourceMappingURL=SchedulerEditTaskContext.js.map